import { render } from "./TableContent.vue?vue&type=template&id=85e8c3de"
import script from "./TableContent.vue?vue&type=script&lang=js"
export * from "./TableContent.vue?vue&type=script&lang=js"

import "./TableContent.vue?vue&type=style&index=0&id=85e8c3de&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__